import Vue from 'vue'
import Router from 'vue-router'
import Index from '@/views/index'
import ParticipationCenter from '@/views/participation_center'
import JoinUs from '@/views/join_us'
import Publish from '@/views/publish'

import Layout from '@/views/layout'

import Meeting from '@/views/meeting'
import Meeting2023 from '@/views/meeting2023'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
    component: Layout,
    redirect:'index',
    children:[
      {
        path:'/',
        name:'index',
        component:Index,
        title:'首页'
      },
      {
        path:'/meeting',
        name:'Meeting',
        component:Meeting,
        title: '学术会议'
      },  {
        path:'/meeting2023',
        name:'Meeting2023',
        component:Meeting2023,
        title: '2023COC'
      },
      {
        path:'/participationCenter',
        name:'ParticipationCenter',
        component:ParticipationCenter,
        title:'参与中心'
      },
      {
        path:'/joinUs',
        name:'JoinUs',
        component:JoinUs,
        title:'加入我们'
      },
      {
        path:'/publish',
        name:'Publish',
        component:Publish,
        title:'发表论文'
      }
      ]
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js